// appCheck.js
// ─────────────────────────────────────────────────────────────────────────────
// Helper for raw fetch() calls to our onRequest Cloud Functions. The Firebase SDK
// attaches the App Check token automatically to callables and Firestore, but our
// fetch-based endpoints (anthropicProxy, agentOrchestrator, approveDocument,
// appendAudit) must add it themselves. Returns the X-Firebase-AppCheck header, or
// {} when App Check isn't initialized (e.g. the site key is unset in dev) so calls
// keep working while server-side enforcement is still off.
// ─────────────────────────────────────────────────────────────────────────────
import { getToken } from "firebase/app-check";
import { appCheck } from "../firebase";

export async function appCheckHeader() {
  if (!appCheck) return {};
  try {
    const { token } = await getToken(appCheck, /* forceRefresh */ false);
    return token ? { "X-Firebase-AppCheck": token } : {};
  } catch (_) {
    return {};
  }
}
